import { connect } from "react-redux"
import { graphql } from "react-apollo"
import SearchBar from "."
import PropTypes from "prop-types"
import { push } from "react-router-redux"
import qs from "query-string"
import gql from "graphql-tag"
import { NotFoundError } from "@swipesense/error-handling"

const query = gql`
  query SearchBar($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      assets {
        id
        name
        assetId
      }
      units {
        id
        name
      }
      departments {
        id
        name
      }
    }
  }
`

const SearchBarWithData = graphql(query, {
  options: props => ({
    variables: {
      facilityId: props.facilityId,
    },
  }),
  props: ({ data: { error, loading, facility }, ownProps }) => {
    if (error && error.networkError) {
      console.warn("Network error, not able to refresh")
      return
    }
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!facility) {
      throw new NotFoundError()
    }
    return {
      allAssets: facility.assets,
      units: facility.units,
      departments: facility.departments,
      ...ownProps,
    }
  },
})(SearchBar)

const mapStateToProps = ({ searchTerms }) => {
  return {
    keywords: searchTerms.keywords,
    unitId: searchTerms.unitId,
    departmentId: searchTerms.departmentId,
  }
}

const mapDispatchToProps = dispatch => ({
  runSearch: searchTerms => {
    dispatch(push({ search: qs.stringify(searchTerms) }))
  },
})

const SearchBarWithStoreWithData = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBarWithData)

SearchBarWithStoreWithData.propTypes = {
  facilityId: PropTypes.string.isRequired,
}

export default SearchBarWithStoreWithData
